import { AuthButton } from "../Components/Auth/AuthButton";
import CBE_Logo from "../images/CBE_logo.png";
import { useMsal } from "@azure/msal-react";
import React, { useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import { faCheck, faFileUpload } from "@fortawesome/free-solid-svg-icons";
import { AdminApi } from "../Api/AdminApi";

interface HeaderProps {
  projectName: string;
  isUpdated?: boolean;
  handleUpdate?: () => void;
  handleSubmit?: () => void;
  questionnaireState?: number;
  userRole?: number;
  loaded: boolean;
  isAdmin?: boolean;
}

function Header({
  projectName,
  isUpdated = false,
  handleUpdate,
  handleSubmit,
  userRole = 0,
  questionnaireState = 0,
  loaded,
  isAdmin = false,
}: HeaderProps) {
    const fileInputRef = useRef<HTMLInputElement>(null);
    const cordaZipFileInputRef = useRef<HTMLInputElement>(null);
  
  useEffect(() => {
    console.log(questionnaireState);
    if (questionnaireState == 1)
      window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      if (questionnaireState == 1)
        window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [questionnaireState]);
  
  const handleBeforeUnload = (event: BeforeUnloadEvent) => {
    event.preventDefault();
  };
  
  const navigate = useNavigate();
  const { instance, accounts } = useMsal();
  const activeAccount = instance.getActiveAccount();
  const idTokenClaims = activeAccount?.idTokenClaims;
  const isInProject = projectName.trim() === "";
    const adminApi = new AdminApi(accounts[0], instance);
  
  useEffect(() => {}, []);
  
  const backToMenu = () => {
    navigate("/");
  };

  // Handle Excel file upload
  const handleFileUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files && files.length > 0) {
      const file = files[0];
      try {
        const result = await adminApi.uploadTooltipsPlaceholders(file);
        alert(`Upload successful: ${result.message}`);
      } catch (error: any) {
        alert(`Upload failed: ${error.response?.data || error.message || 'Unknown error'}`);
      }
      // Reset the file input
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    }
    };

    // Handle CORDA file upload
    const handlecordaZipFileInputRef = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const files = event.target.files;
        if (files && files.length > 0) {
            const file = files[0];
            try {
                const result = await adminApi.uploadCORDAFiles(file);
                alert(`CORDA files submitted for processing successfully`);
            } catch (error: any) {
                alert(`Error submitting CORDA files ${error.response?.data || error.message || 'Unknown error'}`);
            }
            // Reset the file input
            if (cordaZipFileInputRef.current) {
                cordaZipFileInputRef.current.value = '';
            }
        }
    };

  

  return (
    <header>
      <nav className="CBE-navbar">
        <a className="logo" href="/">
          <img src={CBE_Logo} alt="Logo" />
          <div className="divider"></div>
          <span className="title">Project reporting tool</span>
        </a>
        {isInProject ? null : (
          <div className="">
            <div className="project-title">
              {projectName}
              {isUpdated && (
                <span style={{ fontSize: '43px', color: '#5DC07A', marginLeft: '10px' }}>
                  (updated)
                </span>
              )}
            </div>
            {questionnaireState == 1 ? (
              <>
                {userRole == 3 || userRole == 4? null : (
                  <>
                    <div className="button-holder">
                      <input
                        className="big-button mx-auto mt-3"
                        type="submit"
                        value="Save Draft"
                        onClick={handleUpdate}
                      />
                      {userRole == 2 ? (
                        <input
                          className="big-button mx-auto mt-3"
                          type="submit"
                          value="Submit"
                          onClick={handleSubmit}
                        />
                      ) : null}
                    </div>
                  </>
                )}
              </>
            ) : null}
            {questionnaireState == 2 ? (
              <>
                <div className="project-title-state">
                  Submitted
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <FontAwesomeIcon
                      icon={faCheck}
                      style={{ color: "#7ed383" }}
                    />
                  </div>
                </div>
              </>
            ) : null}
            {questionnaireState == 3 ? (
              <>
                <div className="project-title-state">
                  Officer Validated
                  <FontAwesomeIcon
                    icon={faCheck}
                    style={{ color: "#7ed383" }}
                  />
                </div>
              </>
            ) : null}
          </div>
        )}

        <ul className="nav-links">
          {isAdmin ? (
            <>
              <li>
                <a href="/admin"> Manage users</a>
              </li>
              <li>
                <a href="/admin/User/Create"> Create User</a>
              </li>
              <li>
                <a href="/admin/projects"> Manage projects</a>
              </li>
              <li>
                <a href="/admin/project/Create"> Create project</a>
              </li>
              <li>
                <a href="/admin/Roles"> Manage Roles</a>
              </li>
            </>
          ) : null}
                  {isAdmin && (
                      <li>
                          <a href="#" onClick={() => fileInputRef.current?.click()} style={{ display: "flex", alignItems: "center" }}>
                              <FontAwesomeIcon icon={faFileUpload} style={{ marginRight: "5px" }} />
                              Upload Excel
                          </a>
                          <input
                              type="file"
                              ref={fileInputRef}
                              onChange={handleFileUpload}
                              accept=".xlsx,.xls"
                              style={{ display: 'none' }}
                          />
                      </li>)}

                  {isAdmin && (            <li>
              <a href="#" onClick={() => cordaZipFileInputRef.current?.click()} style={{ display: "flex", alignItems: "center" }}>
                <FontAwesomeIcon icon={faFileUpload} style={{ marginRight: "5px" }} />
                Upload CORDA Files
              </a>
              <input
                type="file"
                ref={cordaZipFileInputRef}
                onChange={handlecordaZipFileInputRef}
                accept=".zip"
                style={{ display: 'none' }}
              />
                      </li>

          )}
          <li>
            <AuthButton />
          </li>
          <li>
            Welcome {idTokenClaims?.name} !
          </li>
        </ul>
      </nav>
    </header>
  );
}

export default Header;